import { Module } from "vuex"

export interface ExamState {
  endTime: number // 结束时间戳（毫秒）
  durationMinutes: number // 考试总时长（分钟）
  countdown: { hours: number; minutes: number; seconds: number } // 实时倒计时
  timerId: number | null // 定时器 ID
}

export const Exam: Module<ExamState, unknown> = {
  namespaced: true,

  state: () => ({
    endTime: 0,
    durationMinutes: 0,
    countdown: { hours: 0, minutes: 0, seconds: 0 },
    timerId: null,
  }),

  mutations: {
    setEndTime(state, time: number) {
      state.endTime = time
      localStorage.setItem("examEndTime", String(time)) // 持久化
    },
    setDuration(state, minutes: number) {
      state.durationMinutes = minutes
      localStorage.setItem("examDuration", String(minutes)) // 可选持久化
    },
    setCountdown(state, payload: { hours: number; minutes: number; seconds: number }) {
      state.countdown = payload
    },
    setTimerId(state, id: number | null) {
      state.timerId = id
    },
    clearExam(state) {
      state.endTime = 0
      state.durationMinutes = 0
      state.countdown = { hours: 0, minutes: 0, seconds: 0 }
      state.timerId = null
      localStorage.removeItem("examEndTime")
      localStorage.removeItem("examDuration")
    },
  },

  actions: {
    /**
     * 初始化考试倒计时
     * @param durationMinutes 考试时长（分钟）
     */
    initExam({ commit, dispatch }, durationMinutes: number) {
      const now = Date.now()

      // 先尝试从 localStorage 恢复 endTime
      const savedEndTime = Number(localStorage.getItem("examEndTime") || 0)

      if (savedEndTime && savedEndTime > now) {
        commit("setEndTime", savedEndTime)
      } else {
        const endTime = now + durationMinutes * 60 * 1000
        commit("setEndTime", endTime)
        commit("setDuration", durationMinutes)
      }

      dispatch("startTimer")
    },

    /**
     * 启动全局倒计时
     */
    startTimer({ state, commit, dispatch }) {
      if (state.timerId) {
        clearInterval(state.timerId)
        commit("setTimerId", null)
      }

      const update = () => {
        const diff = state.endTime - Date.now()
        if (diff <= 0) {
          commit("setCountdown", { hours: 0, minutes: 0, seconds: 0 })
          dispatch("stopTimer")
          return
        }

        const hours = Math.floor(diff / (1000 * 60 * 60))
        const minutes = Math.floor((diff / (1000 * 60)) % 60)
        const seconds = Math.floor((diff / 1000) % 60)

        commit("setCountdown", { hours, minutes, seconds })
      }

      update() // 立即执行一次
      const id = window.setInterval(update, 1000)
      commit("setTimerId", id)
    },

    stopTimer({ state, commit }) {
      if (state.timerId) {
        clearInterval(state.timerId)
        commit("setTimerId", null)
      }
    },

    finishExam({ commit, dispatch }) {
      dispatch("stopTimer")
      commit("clearExam")
    },
  },

  getters: {
    getCountdown(state) {
      return state.countdown
    },
    getEndTime(state) {
      return state.endTime
    },
    getDuration(state) {
      return state.durationMinutes
    },
  },
}
